<template>
  <transition name="fade">
    <div class="confirm" v-show="showFlag" @click.stop>
      <div class="confirm-wrapper">
        <div class="confirm-content">
          <div class="content-inner">
            <em class="icon" :class="{'xiaolian':iconStatus, 'kulian': !iconStatus}" v-show="isShowIcon"></em>
            <p class="text" :class="{'duan': isShowIcon}">{{text}}</p>
          </div>
          <div class="operate">
            <div class="operate-btn left" @click="cancel" v-if="showCancel">{{cancelBtnText}}</div>
            <div class="operate-btn" @click="confirm">{{confirmBtnText}}</div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    text: {
      type: String,
      default: ""
    },
    isShowIcon: {
      type: Boolean,
      default: false
    },
    iconStatus: {
      type: Boolean,
      default: true
    },
    confirmBtnText: {
      type: String,
      default() {
        return this.$t('userCenter.confirmText')
      }
    },
    cancelBtnText: {
      type: String,
      default() {
        return this.$t('userCenter.cancelText')
      }
    },
    showCancel: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showFlag: false
    };
  },
  methods: {
    show() {
      this.showFlag = true;
    },
    hide() {
      this.showFlag = false;
    },
    cancel() {
      this.hide();
      this.$emit("cancel");
    },
    confirm() {
      this.hide();
      this.$emit("confirm");
    }
  }
};
</script>

<style scoped lang="scss" rel="stylesheet/scss">
@import "@/assets/scss/variable.scss";

.confirm {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 998;
  background-color: rgba(0, 0, 0, 0.6);
}

.confirm-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
}

.confirm-content {
  width: 354px;
  border-radius: 13px;
  animation: confirm-zoom 0.3s;
  background: #fff;
}

.content-inner {
  padding: 30px 30px;
  text-align: center;
  .icon {
    width: 33px;
    height: 33px;
    display: inline-block;
    vertical-align: middle;
    &.xiaolian {
      background: url(~@/assets/images/xiaolian.png) no-repeat left top;
      background-size: 100% 100%;
    }
    &.kulian {
      background: url(~@/assets/images/kulian.png) no-repeat left top;
      background-size: 100% 100%;
    }
  }
  .text {
    line-height: 22px;
    text-align: center;
    font-size: 18px;
    color: $mainFont;
    vertical-align: middle;
    display: inline-block;
    &.duan {
      max-width: 240px;
      padding-left: 10px;
    }
  }
}

.operate {
  display: flex;
  align-items: center;
  text-align: center;
  font-size: 18px;
}

.operate-btn {
  flex: 1;
  line-height: 22px;
  padding: 15px 0;
  border-top: 1px solid #ccc;
  color: $mainFont;
  cursor: pointer;
  &.left {
    border-right: 1px solid #ccc;
  }
}

@keyframes confirm-zoom {
  0% {
    transform: scale(0);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Confirm.vue